module.exports = __webpack_public_path__ + "img/open-data-form-header.68d09a2f.svg";